module.exports = __webpack_public_path__ + "img/hero_image_newsflashes_mobile.72130ab.jpg";